export const EVENT_TYPES__QUESTION = 1;
export const EVENT_TYPES__LYRIC = 2;
export const EVENT_TYPES__CLEAR = 3;
